import { ConfigProvider } from "antd";
import React, { useEffect, useState } from "react";
import BigCard from "../components/common/BigCard";
import FilterSearch from "../components/common/FilterSearch";
import CategoriesSec from "../components/layouts/Cat/CategoriesSec";
import fa_IR from "antd/locale/fa_IR";
import useFetch from "../hooks/useAxios";
import GuestCount from "../components/layouts/Cat/ModalFilter.js/GuestCount";
import CostInDays from "../components/layouts/Cat/ModalFilter.js/CostInDays";
import Instancedelivery from "../components/layouts/Cat/ModalFilter.js/Instancedelivery";
import TypeofResidence from "../components/layouts/Cat/ModalFilter.js/TypeofResidence";
import ChooseFirstDateModal from "../components/layouts/Cat/ModalFilter.js/ChooseFirstDateModal";
import ChooseSecDateModal from "../components/layouts/Cat/ModalFilter.js/ChooseSecDateModal";
import { useSearchParams } from "react-router-dom";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import CityModal from "../components/layouts/Cat/ModalFilter.js/CityModal";
import Button from "../components/shared/Button";
import CatMap from "../components/layouts/Cat/CatMap";
import { useMap } from "react-leaflet";
import mapicon from "../assets/img/icons/map.svg"
import PersianPagination from "../components/shared/Paginatio";
import ChooseReg from "../components/layouts/Cat/ModalFilter.js/ChooseReg";
const Categories = () => {
  const [searchparams] = useSearchParams();
  const [Stateinfo, setStateinfo] = useState([]);
  const [StateResults, setStateResults] = useState([]);
  const [Ads, setAds] = useState();
  const [OrderingSort, setOrderingSort] = useState(); //popular//minp//maxp

  const [chosenCity, setChoseCity] = useState([]
  );
  useEffect(() => {
    apiCityInfo.reFetch()
  }, [])
  useEffect(() => {
    if( StateResults.length > 0 && searchparams.get("cities")){
      setChoseCity(StateResults.filter(i=>i.name === searchparams.get("state"))[0].cities?.filter(j=>searchparams.get("cities").split("-").includes(j.name)))
    }
  }, [StateResults])
  
  

  const [totalPage, settotalPage] = useState(10);
  const [currentPage, setcurrentPage] = useState(1);

  const [mapshow, setmapshow] = useState(false);
  const [markers, setmarkers] = useState([{ lat: 51.505, lng: -0.09, name: 'London' },
  { lat: 48.8566, lng: 2.3522, name: 'Paris' },
  { lat: 52.5200, lng: 13.4050, name: 'Berlin' }])
  const [count, setcount] = useState(JSON.parse(searchparams.get("cap")) !== null ?searchparams.get("cap")   :0);
  const [choseCityId, setchoseCityId] = useState([]); //city //start //end //count
  const [firstCostvalue, setfirstCostvalue] = useState(0);
  const [secCostValue, setsecCostValue] = useState();
  const [FastDeliveryValue, setFastDeliveryValue] = useState(false);
  const [ShowFastDeliveryModal, setShowFastDeliveryModal] = useState(false);
  const [GuestcountModal, setGuestcountModal] = useState(false);
  const [ShowCostModal, setShowCostModal] = useState(false);
  const [ShowResideceTypeModal, setShowResideceTypeModal] = useState(false);
  const [ShowCityModal, setShowCityModal] = useState(false);
  const [ShowRegModal, setShowRegModal] = useState(false);
  const [RegType, setRegType] = useState([]);
  const [ShowFirstDateModal, setShowFirstDateModal] = useState(false);
  const [ShowSecDateModal, setShowSecDateModal] = useState(false);
  const [FirstDateValue, setFirstDateValue] = useState(
  searchparams.get("endate")!==null? searchparams.get("endate"): null
  );
  const [SecDateValue, setSecDateValue] = useState(
  searchparams.get("ledate") !== null ? searchparams.get("ledate") : null
  );
  const [inforesidence, setinforesidence] = useState();
const [choseType, setChosenType] = useState(searchparams.get("type") ?  searchparams.get("type").split("-").map(key => ({name: key})):[])



useEffect(() => {
 if(searchparams.get("type")){
  setChosenType(searchparams.get("type").split("-").map(key => ({name: key})))
 }
}, [searchparams.get("type")])
useEffect(() => {
  apiGetresidenceInfo.reFetch()
}, [searchparams.get("type")])
console.log(searchparams.get("type"),"typeeee");
console.log(choseType,"typeeee");
const apiGetresidenceInfo = useFetch({
  method: "get",
  url:chosenCity.length > 0
    ? `api/residences/s/${chosenCity.map(i => i.name).toString().replace(/,/g, "-")}`:
    searchparams.get("city") ? `api/residences/s/${searchparams.get("city")}`
    : `api/residences/s`,
  noHeader: true,
  trigger: false,
  params: {
    page:currentPage,
    instant:FastDeliveryValue?FastDeliveryValue:null,
    minp:firstCostvalue,
    maxp:secCostValue,
    endate : FirstDateValue!==null ?FirstDateValue : null,
    eldate:SecDateValue  !==null?SecDateValue : null,
    order:OrderingSort,
    reg:RegType.length>0 ? RegType.map(i => i.value).toString().replace(/,/g, "-") : null,
 // cap:count,ß
  type:choseType.map(i => i.name).toString().replace(/,/g, "-"),
  },
  argFunc: res => {setinforesidence(res.data.residences)
    settotalPage(res.data.total_residences)
    setAds(res.data.ads)
  }
});

const apiCityInfo = useFetch({
  method: "get",
  url: "api/locations",
  noHeader: true,
  trigger: false,
 
  argFunc: res => {
    setStateinfo(res.data);
    setStateResults(res.data);
  }
});
useEffect(() => {
  if(OrderingSort){
    apiGetresidenceInfo.reFetch()

  }
}, [OrderingSort])
useEffect(() => {
  if(currentPage ){
    apiGetresidenceInfo.reFetch()

  }
}, [currentPage])
const maxprice = useFetch({
  method: "get",
  url: "api/residences/max-price",
  noHeader: true,
  trigger: true,
  argFunc: res => {
    setsecCostValue(res.data.max_price)
    
  }
});

useEffect(() => {

    apiGetresidenceInfo.reFetch()

  
}, [chosenCity])


  const useFilter = ()=>{
    apiGetresidenceInfo.reFetch()
  }

  return (

    <ConfigProvider locale={fa_IR}>
      <div>
        <div className="container">
    
          <div className="Categories--header">
            <h2>{inforesidence?.length} اقامتگاه موجود می باشد</h2>
            <p></p>
          </div>
          <div>
            
          </div>
        </div>
        <FilterSearch
        setShowRegModal={()=>setShowRegModal(true)}
          openFastDeliverModal={() => setShowFastDeliveryModal(true)}
          openCostModal={() => setShowCostModal(true)}
          openGuestModal={() => setGuestcountModal(true)}
          openCityModal={() => setShowCityModal(true)}
          opentTypeModal={() => setShowResideceTypeModal(true)}
          openFirstDateModal={() => setShowFirstDateModal(true)}
          openSecDateModal={() => setShowSecDateModal(true)}
          FirstDateValue={FirstDateValue}
          SecDateValue={SecDateValue}
          chosenCity={chosenCity}
          count={count}
          useFilter={useFilter}
          OrderingSort={OrderingSort}
          setOrderingSort={setOrderingSort}
          
        />
        {inforesidence && <CategoriesSec inforesidence={inforesidence} />}
        <div className="container">
        <PersianPagination total={totalPage} setcurrentPage={setcurrentPage} /> 
        {Ads && <BigCard info={Ads} />}
        </div>
       
        <div className="button_cat">
          <Button varient="fifth" onClick={()=>setmapshow(true)}>
            
            <div className="flex gap-[8px]">
              <img src={mapicon}/>
              <div>نمایش نقشه</div>

            </div>
            </Button>
        </div>
      </div>
      {GuestcountModal &&
        <GuestCount
          closeModal={() => setGuestcountModal(false)}
          count={count}
          setCount={setcount}
        />}
      {ShowCostModal &&
        <CostInDays
          firstvalue={firstCostvalue}
          setfirstvalue={setfirstCostvalue}
          secvalue={secCostValue}
          setsecvalue={setsecCostValue}
          closeModal={() => setShowCostModal(false)}
    
        />}
      {ShowFastDeliveryModal &&
        <Instancedelivery
          closeModal={() => setShowFastDeliveryModal(false)}
          value={FastDeliveryValue}
          setvalue={setFastDeliveryValue}
        />}
      {ShowCityModal &&
        <CityModal
          setchoseCityId={setchoseCityId}
          choseCityId={choseCityId}
          setChoseCity={setChoseCity}
          chosenCity={chosenCity}
          closeModal={() => setShowCityModal(false)}
          Stateinfo={Stateinfo}
          setStateinfo={setStateinfo}
          StateResults={StateResults}
          setStateResults={setStateResults}
         
        />}
      {ShowResideceTypeModal &&
        <TypeofResidence choseType={choseType} setChosenType={setChosenType} closeModal={() => setShowResideceTypeModal(false)} />}
      {ShowFirstDateModal &&
        <ChooseFirstDateModal
          closeModal={() => setShowFirstDateModal(false)}
          selectedDay={FirstDateValue}
          setSelectedDay={setFirstDateValue}
        />}
      {ShowSecDateModal &&
        <ChooseSecDateModal
          closeModal={() => setShowSecDateModal(false)}
          selectedDay={SecDateValue}
          setSelectedDay={setSecDateValue}
        />}
        {
          mapshow && <CatMap closeModal={()=>setmapshow(false)}   markerPos={markers} setMarkerPos={setmarkers} />
        }
        {
          ShowRegModal && <ChooseReg chosenReg={RegType} setChoseReg={setRegType} closeModal={()=>setShowRegModal(false)}/>
        }
    </ConfigProvider>
  );
};

export default Categories;
